<section class="row justify-content-center">
    <div class="col-12 pt-5 maintenance-page d-flex flex-column align-items-center">
        <h1>{{ 'MAINTENANCE.TITLE' | translate }}</h1>
        <h3 class="mt-3">{{ 'MAINTENANCE.SUBTITLE' | translate }}</h3>
    </div>
</section>
